import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { listSerializationHelper, objectSerializationHelper } from "helpers/next-helpers";
import $ from "clients/RawClient";

const initialState = {
  reviewsThumbnailPhotos: {
    loading: false,
    moments: [],
    totalCount: 0,
  },
};

export const fetchReviewsThumbnailPhotos = createAsyncThunk(
  "reviewsThumbnailPhotos/fetchReviewsThumbnailPhotos",
  async (params, { rejectWithValue }) => {
    const { productId, ...queryParams } = params;

    if (!productId) {
      return rejectWithValue({ moments: [], totalCount: 0, loading: false });
    }

    try {
      const response = await $.ajax({
        type: "GET",
        url: `/api/products/${productId}/cover-photos`,
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json; charset=utf-8",
        },
        data: queryParams,
      });

      return response;
    } catch {
      return rejectWithValue({ moments: [], totalCount: 0, loading: false });
    }
  }
);

export const reviewThumbnailPhotoSlice = createSlice({
  name: "reviewsThumbnailPhotos",
  initialState,
  extraReducers: builder => {
    builder
      .addCase(fetchReviewsThumbnailPhotos.pending, state => {
        if (!state.reviewsThumbnailPhotos) {
          state.reviewsThumbnailPhotos = {};
        }
        state.reviewsThumbnailPhotos.loading = true;
      })

      .addCase(fetchReviewsThumbnailPhotos.fulfilled, (state, action) => {
        const payload = objectSerializationHelper(action.payload);
        const current = state.reviewsThumbnailPhotos;

        const shouldMerge =
          current?.moments?.[0]?.styleName && current.moments[0].styleName === payload?.moments?.[0]?.styleName;

        const mergedMoments = shouldMerge
          ? [...listSerializationHelper(current?.moments || []), ...(payload?.moments || [])]
          : payload?.moments || [];

        state.reviewsThumbnailPhotos = {
          ...payload,
          moments: mergedMoments,
          loading: false,
        };
      })

      .addCase(fetchReviewsThumbnailPhotos.rejected, (state, action) => {
        if (!state.reviewsThumbnailPhotos) {
          state.reviewsThumbnailPhotos = {};
        }
        const fallback = action.payload || { moments: [], totalCount: 0 };
        state.reviewsThumbnailPhotos = {
          ...fallback,
          loading: false,
        };
      });
  },
});

export const types = [
  "reviewsThumbnailPhotos/fetchReviewsThumbnailPhotos/pending",
  "reviewsThumbnailPhotos/fetchReviewsThumbnailPhotos/fulfilled",
  "reviewsThumbnailPhotos/fetchReviewsThumbnailPhotos/rejected",
];

export default {
  types,
  fn: reviewThumbnailPhotoSlice.reducer,
};
